var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.networks),function(network,key){return _c('a',{key:key,attrs:{"href":network.url,"target":"_blank"}},[_c('img',{attrs:{"src":(_vm.baseUrl + "/social-icon-" + (network.name) + ".svg"),"alt":network.name}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }